// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  padding: 10px 0;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 500;
  height: 55px;
}

.bottom-nav button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  width: 60px;
  transition: opacity 0.2s;
}

.bottom-nav button:hover {
  opacity: 0.8;
}

.bottom-nav button .icon {
  font-size: 22px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.bottom-nav button .label {
  font-size: 12px;
  text-align: center;
  margin-top: 3px;
  white-space: nowrap;
}

/* Скрываем нижнее меню на ПК и планшетах */
@media (min-width: 768px) {
  .bottom-nav {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BottomNav/BottomNav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".bottom-nav {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background: white;\r\n  padding: 10px 0;\r\n  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  z-index: 500;\r\n  height: 55px;\r\n}\r\n\r\n.bottom-nav button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 6px;\r\n  width: 60px;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.bottom-nav button:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.bottom-nav button .icon {\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.bottom-nav button .label {\r\n  font-size: 12px;\r\n  text-align: center;\r\n  margin-top: 3px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Скрываем нижнее меню на ПК и планшетах */\r\n@media (min-width: 768px) {\r\n  .bottom-nav {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
